// extracted by mini-css-extract-plugin
export default {"pagination":"pagination_pagination__djZ22","pagination__container":"pagination_pagination__container__ExmM+","activePaginate":"pagination_activePaginate__A-YGN"};